import { Formik, Form } from 'formik';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router';
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import Breadcrumb from 'src/components/Common/Breadcrumb'
import InputCom from 'src/components/Common/Input';
import CheckboxInput from 'src/components/UI/CheckboxInput';
import * as Yup from 'yup';
import { ROUTER } from 'src/constants/routes';
import Dropzone from "react-dropzone";
import Button from 'src/components/UI/Button';
import { FieldModal } from 'src/models/components/inputWrapperModel';
import { vehicleBrandsDetails } from 'src/models/pages/vehicleBrandsModel';
import { useDispatch, useSelector } from 'react-redux';
import { RootReducerState } from 'src/store/reducers';
import { clearVehicleBrandsMessage, createVehicleBrands, deleteVehicleBrandImageLoading, getVehicleBrandImageLoading, getVehicleBrandsBYID, resetVehicleBrand, updateVehicleBrands, uploadVehicleBrandFileLoading } from 'src/store/actions';
import { useToast } from "src/components/Common/ReactToaster";
import ValidationPopup from 'src/components/Common/ValidationMessage/ValidationPopup';
import { FILE_UPLOAD_SIZE } from 'src/constants/commonConstants';
import ImagePreviewer from 'src/components/Common/ImagePreviewer/ImagePreviewer';
import { onDropRejectedFileHandler } from 'src/helpers/common_helpers';
import DeleteModal from 'src/pages/Calendar/DeleteModal';
import { vehicleBrandImageDeleteSuccess } from 'src/store/vehicleBrands/reducer';
const AddEditVehicleBrands: React.FC = () => {
  const [selectedFiles, setselectedFiles] = useState<any>([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [localFormFields, setLocalFormFields] = useState<FieldModal[]>([]);
  const { id } = useParams()
  const { showToast } = useToast();



  const dispatch = useDispatch();
  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),

  });
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      dispatch(getVehicleBrandsBYID(id));
      dispatch(getVehicleBrandImageLoading(id))
    }

    
    return () => {
      dispatch(resetVehicleBrand())
    }
  }, [id, dispatch]);

  const formValue: vehicleBrandsDetails = useSelector(
    (state: RootReducerState) => state.vehicleBrandsReducer?.vehicleBrandsDetails as vehicleBrandsDetails
  );

  const { error, message, loading, vehicleBrandImage } = useSelector(
    (state: RootReducerState) => state.vehicleBrandsReducer
  );

  const initialvalue = {
    name: (formValue?.['name'] || ""),
    isTv: (formValue?.['isTv'] || false),
  }
  const [visible, setVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    if (error) {
      setVisible(true)
      setIsSubmitting(false)
    }
    if (message !== "" && message != undefined) {
      showToast(message, { type: "success" });
      if (message != vehicleBrandImageDeleteSuccess) {
        dispatch(clearVehicleBrandsMessage())
        setTimeout(() => {
          setIsSubmitting(false)
          navigate(ROUTER.VEHICLE_BRANDS_GRID)
        }, 500)
        if (id) {
          dispatch(getVehicleBrandsBYID(id))
        } else {
          navigate(ROUTER.VEHICLE_BRANDS_GRID);
        }
      }else{
        dispatch(clearVehicleBrandsMessage())
        if (id) {
          dispatch(getVehicleBrandsBYID(id))
        }

 
      }
    

    }
  }, [error, message])

  useEffect(() => {
    const preloader: any = document.getElementById("preloader");
    if (loading) {
      preloader.style.display = "block";
    } else {
      preloader.style.display = "none";
    }

  }, [loading]);

  const hidePopup = () => {
    setVisible(false);
    dispatch(clearVehicleBrandsMessage())
  }

  const dialogContainer = (error: any) => {
    return (
      <>
        <ValidationPopup error={error} visible={visible} onHide={hidePopup} />
      </>
    )
  }

  const handleSubmit = async (values: any) => {
    if (isSubmitting) return
    const submittedData: vehicleBrandsDetails = {
      name: values.name as string,
      isTv: values.isTv as boolean
    }
    setIsSubmitting(true)
    id ? update(submittedData) : post(submittedData);
  };

  const update = (formValue: vehicleBrandsDetails) => {
    dispatch(updateVehicleBrands(formValue, id));
    if (selectedFiles.length > 0) {
      dispatch(uploadVehicleBrandFileLoading(selectedFiles[0], id))
    }
  };


  const post = (formValue: vehicleBrandsDetails) => {
    dispatch(createVehicleBrands(formValue));
  };
  function handleAcceptedFiles(files: any) {
    let filesModified = files.map((file: any) => {
      return Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
        isImage: file.type.startsWith('image/')
      })
    }
    );

    if (filesModified[0]?.isImage) {
      if (filesModified[0]?.size <= FILE_UPLOAD_SIZE) {
        setselectedFiles(files);
      } else {
        showToast("File size exceeds 5MB", { type: "error" })
        setselectedFiles([]);
      }
    } else {
      showToast("Please upload the image file", { type: "error" })
      setselectedFiles([]);
    }

  }

  function formatBytes(bytes: any, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
  const removeIndex = () => {
    setDeleteModal(false);
    if (vehicleBrandImage) {
      dispatch(deleteVehicleBrandImageLoading(id))
    } else if (selectedFiles.length > 0) {
      setselectedFiles([]);
    }
  };
  const deleteConfirmationHandler = () => {
    setDeleteModal(true);
  }

  const handleReset = (resetForm: any) => {
    resetForm(getEmptyInitialValues());
    if (id) {
      navigate(ROUTER.VEHICLE_BRANDS_GRID)
    }
  }

  const getEmptyInitialValues = () => {
    const initialValue = localFormFields?.reduce((acc: any, field: any) => {
      if (field.type !== 'checkbox') {
        acc[field.name] = '';
      } else {
        acc[field.name] = false;
      }
      return acc;
    }, {});
    return { ...initialValue, name: '', isTv: false };
  };

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={() => {
          removeIndex()
        }}
        onCloseClick={() => {
          setDeleteModal(false);
        }}
      />
      {visible && dialogContainer(error)}
      <div className="page-content" id="view-brand">
        <Container fluid>
          <Breadcrumb title="Vehicle Brands" titlePath={ROUTER.VEHICLE_BRANDS_GRID} breadcrumbItem={`${id ? "Edit Vehicle Brand" : "Create Vehicle Brand"}`} />
          <Row>
            <Card>
              <CardBody>
                <React.Fragment>
                  <Formik
                    onSubmit={handleSubmit}
                    initialValues={initialvalue}
                    validationSchema={validationSchema}
                    enableReinitialize>
                    {({ values, handleChange, touched, errors, handleBlur, resetForm, reset, ...rest }: any) => {
                      return (
                        <Form onChange={handleChange}>
                          <Row>
                            <Col lg={4} >
                              <InputCom labelName="Name"
                                inputclassName="form-control"
                                labelClassName="form-Label"
                                type="text"
                                name="name"
                                onBlur={handleBlur}
                                value={values.name}
                                onChange={handleChange}
                                isRequired={true}
                                invalid={touched["name"] && errors["name"] ? true : false}
                              />

                            </Col>
                            <Col lg={4} className="mb-2 d-flex flex-column justify-content-center">
                              <CheckboxInput
                                name="isTv"
                                label="Is TV Service"
                                value={values.isTv}
                                onChange={handleChange}
                                {...rest}
                              />
                              <p className="text-muted mb-0 mt-1" style={{ fontSize: "12px" }}>
                                (If checked here it will only used for tv service)
                              </p>
                            </Col>
                            {id && <React.Fragment>
                              <div className="mt-1">
                                <h5>Image</h5>
                                <hr />
                                <Row>
                                  <Col sm={12} lg={12} md={12} xs={12}>
                                    <div>
                                      {(selectedFiles.length == 0 && !vehicleBrandImage) && <Dropzone
                                        onDrop={acceptedFiles => {
                                          handleAcceptedFiles(acceptedFiles);
                                        }}
                                        onError={(err: Error) => { console.log("file error", err) }}
                                        onDropRejected={(fileRejections, event) => onDropRejectedFileHandler(fileRejections, event, showToast)}
                                        maxFiles={1}
                                      >
                                        {({ getRootProps, getInputProps }) => (
                                          <div className="dropzone">
                                            <div
                                              className="dz-message needsclick"
                                              {...getRootProps()}
                                            >
                                              <input {...getInputProps()} accept="image/*" />
                                              <div className="">
                                                <i className="display-4 text-muted bx bx-cloud-upload" />
                                              </div>
                                              <h4>Drop files here or click to upload.</h4>
                                            </div>
                                          </div>
                                        )}
                                      </Dropzone>}

                                      {(selectedFiles[0]?.preview || vehicleBrandImage) && <ImagePreviewer selectedFile={selectedFiles[0]?.preview ? selectedFiles[0]?.preview : vehicleBrandImage} removeIndex={deleteConfirmationHandler} />}
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </React.Fragment>}
                            <div className="d-flex justify-content-end mt-2">
                              <Button
                                className="secondary-btn me-2"
                                label={id ? "Cancel" : "Reset"}
                                type="button"
                                onClick={() => handleReset(resetForm)}
                              />
                              <Button
                                className="btn-primary me-2 btn-primary-shadow"
                                label={id ? "Update Vehicle Brand" : "Create Vehicle Brand"}
                                type="submit"
                              />
                            </div>

                          </Row>


                        </Form>
                      )
                    }}
                  </Formik>
                </React.Fragment>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AddEditVehicleBrands